import React, { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { DictionaryData, useTranslation } from 'app/lang';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

import styles from './UnionsMenu.module.scss';

type LinkContentProps = PropsWithChildren<{
  caption?: string;
  label?: string | DictionaryData;
  iconURL?: string;
}>;

export const LinkContent: FC<LinkContentProps> = ({
  iconURL,
  caption,
  label,
  children,
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isUnionIcons = useFeatureFlag(FeatureFlag.LEFT_MENU_UNION_ICONS);
  const isLive = pathname.startsWith('/live');

  return (
    <>
      {isUnionIcons && (
        <span className={styles.iconContainer}>
          <img src={iconURL}
               className={styles.icon}
               width={23}
               height={21}
               alt="Лого объединения" />
        </span>
      )}
      <span data-test="item-label"
            className={styles.label} >
        {getDictionaryDataItems(t, label)}
      </span>
      {(caption && isLive) && (
        <span data-test="item-caption"
              className={styles.caption}>
          {caption}
        </span>
      )}
      {children}
    </>
  );
};
